module.exports = __webpack_public_path__ + "files/f57e94498e8f72c88457bbd69bacfbcd.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/audio.png
// module id = 409
// module chunks = 76